import {is, type Map, type Record} from 'immutable';
import {createSelectorCreator, defaultMemoize} from 'reselect';

export const immutableSelectorCreator = createSelectorCreator(defaultMemoize, is);

/**
 * Allows you to type a Map with an interface
 */
export interface ImmutableMap<T> extends Map<string, any> {
    get: <K extends keyof T>(name: K) => T[K];
}

export type InferRecord<T extends Record<any>> = T extends Record<infer U> ? U : never;
